module.exports = __webpack_public_path__ + "img/success_detection.ffddf833.png";